module.exports = __webpack_public_path__ + "media/images/dcs-28ccf01c527558fd50ccac3db288b7f1.png";